<template>
  <v-dialog :value="value" @input="$emit('input', $event)" :max-width="width" persistent>
    <v-card class="rounded-lg pa-4">
      <slot></slot>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    value: { type: Boolean, default: false },
    width: { type: String, default: '600px' },
  },
};
</script>
